import Types from '../Types'

export default (api = undefined) => ({
    type: Types.APP.CLEARERROR,
    api
})



// WEBPACK FOOTER //
// ./src/actions/app/ClearErrorAction.js